export const siteLogo = {
    logo: "assets/images/wonted-logo.png",
    alt :"Wonted" // Add your site logo here alt: "Wonted" // Add your site name here
};

export const socialLink = {
    facebook: "https://www.facebook.com",
    twitter: "https://www.twitter.com",
    linkedin: "https://www.linkedin.com",
    youtube: "https://www.youtube.com",
    whatsapp: "https://www.whatsapp.com"
};